import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'form-actions',
  templateUrl: './form-actions.component.html'
})
export class FormActionsComponent {

  //default to true so user can click the button if no value is given
  @Input() isDirty: boolean = true;
  @Input() disabled: boolean = false;

  @Output() saveEvent = new EventEmitter();
  @Output() cancelEvent = new EventEmitter();

  public save(): void {
    this.saveEvent.emit(null);
  }

  public cancel(): void {
    this.cancelEvent.emit(null);
  }
}
